<template>
  <div
    id="app"
    :style="style.global"
  >
    <router-view />
  </div>
</template>

<script>
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'app',
    data: function () {
      return {
        style: {
          global: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
            minWidth: '380px',
            '-webkit-font-smoothing': 'antialiased',
            'moz-osx-font-smoothing': 'grayscale',
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.global,
        {
          backgroundColor: this.color.background1(),
          color: this.color.dark2(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
